import type { IFile } from '@/types/global';

interface PhotoObjectProps {
  value: IFile;
}

export const PhotoObject = ({ value }: PhotoObjectProps) => (value ? <img src={value.path} style={{ width: '100%' }} /> : <></>);
